import { useMemo, useState } from 'react';

import { useTeamMembers } from '../context';
import { getTeamMemberDisplayName } from '../utils/getTeamMemberDisplayName';

export interface TeamMemberOption {
  value: string;
  label: string;
}

export function useTeamMemberParticipants() {
  const { state } = useTeamMembers();

  const teamMemberOptions: TeamMemberOption[] = useMemo(
    () =>
      state.teamMembers.map((member) => ({
        label: getTeamMemberDisplayName(member),
        value: member.id,
      })),
    [state.teamMembers],
  );

  const [participants, setParticipants] = useState<TeamMemberOption[]>([]);

  const participantIds = useMemo(
    () => participants.map((p) => p.value),
    [participants],
  );

  return { teamMemberOptions, participants, setParticipants, participantIds };
}
